import { useState } from 'react';


import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import InsightScreenshot, {
  type InsightScreenshotComment,
} from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/insight-screenshot';
import CommentsPanel from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/comments-panel';
import ContextDataPanel from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/context-data-panel';

import type { InsightDto } from 'api/generated/schemas/insightDto';
import type { UserInsightDto } from 'api/generated/schemas/userInsightDto';

import Icons from 'assets/icons';

interface InsightDetailsTabProps {
  insight: (InsightDto | UserInsightDto) | null | undefined;
  comments?: InsightScreenshotComment[];
  commentsLoading: boolean;
  isAdminView?: boolean;
}

const InsightDetailsTab = ({
  insight,
  comments,
  commentsLoading,
  isAdminView = true,
}: InsightDetailsTabProps): React.JSX.Element => {
  const [selectedCommentId, setSelectedCommentId] = useState<
    string | number | null
  >(null);

  const handleCommentClick = (commentId: string | number): void => {
    setSelectedCommentId(commentId);
  };

  return (
    <div className="space-y-5">
      {insight?.description && (
        <Box
          sx={{
            bgcolor: 'tokens.blue.50',
            borderWidth: '1px',
            borderColor: 'tokens.blue.300',
            borderRadius: '0.375rem',
            p: 2.5,
            mb: 3.5,
          }}
        >
          <Stack
            direction="row"
            sx={{ alignItems: 'center', gap: 0.5, mb: 0.5 }}
          >
            <Icons.Idea customClass="size-4 text-blue-700" />

            <Box
              sx={{
                fontSize: '1.125rem',
                lineHeight: '1.75rem',
                fontWeight: 600,
                color: 'tokens.blue.700',
              }}
            >
              Summary
            </Box>
          </Stack>
          <p className="text-gray-700">{insight.description}</p>
        </Box>
      )}

      <Stack direction="row" sx={{ gap: 4 }}>
        <div className="flex-1 space-y-4">
          <Stack
            direction="row"
            sx={{
              borderWidth: '1px',
              borderColor: 'tokens.gray.200',
              borderRadius: '0.5rem',
              p: 2,
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <InsightScreenshot
              imageUrl={insight?.imageUrl}
              comments={comments}
              selectedCommentId={selectedCommentId}
              onCommentClick={handleCommentClick}
            />
          </Stack>
        </div>

        <Box sx={{ width: '33.333333%' }}>
          <CommentsPanel
            comments={comments}
            loading={commentsLoading}
            selectedCommentId={selectedCommentId}
            onCommentClick={handleCommentClick}
          />
        </Box>
      </Stack>
      <ContextDataPanel insight={insight} isAdminView={isAdminView} />
    </div>
  );
};

export default InsightDetailsTab;
